import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconImage = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2M8.5 13.5l2.5 3.01L14.5 12l4.5 6H5z" />
  </SvgIcon>
);

export default IconImage;



// WEBPACK FOOTER //
// ./src/components/icons/IconImage.js